<template>
    <div>
        <COMMENTS
                :comments-list="comments"
                :total="total"
                :page-num="pageNum"
                :page-size="pageSize"
                :loading="commentsLoading"
                :page-change="commentsPageChange"
                :submit-comments="submitComment"
                :delete-comments="deleteComments"
        >

        </COMMENTS>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import COMMENTS from '../../../common/comments'
    export default {
        name:'comments',
        components:{
            COMMENTS
        },
        props:{
            competJoinId:{
                type:Number,
                required:true,
            }
        },
        data(){
            return {
                pageSize:9,
                pageNum:1,
                total:0,
                commentsLoading:false,
                comments: [],
            }
        },
        methods:{
            ...mapActions({
                getOpenUserComments:'contest/getOpenUserComments',
                setOpenContestUserComments:'contest/setOpenContestUserComments',
                deleteOpenContestComment:'contest/deleteOpenContestComment',
            }),
            // 评论分页
            commentsPageChange(page){
                this.pageNum = page;
                this.getComments();
            },
            //提交评论
            submitComment(obj){
                let _this = this;
                this.setOpenContestUserComments({
                    id:this.competJoinId,
                    data:{
                        reply_id:obj.reply_id,
                        comment:obj.comment,
                    },
                    callback:res=>{
                        _this.$Message.success("评论成功");
                        _this.getComments();
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                });
                return true;
            },
            // 获取公开 code 评论
            getComments(){
                let _this = this;
                this.getOpenUserComments({
                    compet_join_id:_this.competJoinId,
                    data: {
                        page_num: _this.pageNum,
                        page_size: _this.pageSize,
                    },
                    callback:res=>{
                        _this.comments = res.body;
                        _this.total = res.page.count;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
            // 删除评论
            deleteComments(commentId){
                let _this = this;
                this.deleteOpenContestComment({
                    data:{
                        join_id:_this.competJoinId,
                        ids:[commentId]
                    },
                    callback:res=>{
                        _this.$Message.success("删除成功");
                        _this.getComments();
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
        },
        watch:{
            competJoinId:(value,oldValue)=>{
                this.getComments();
            }
        },
        created(){
            this.getComments();
        }
    }
</script>
